<template>
  <div id="reviews-modal" ref="modal_body">
    <b-row class="reviews__modal-body">
      <b-col
        v-for="(review, i) in reviews" 
        :key="review.id || ('review-' + i)"
        :ref="review.id || ('review-' + i)"
        :id="review.id || ('review-' + i)"
        sm="12"
      >
        <review   
          :rating="Number(review.rating)" 
          :reviewer="review.reviewer"
          :title="review.title"
          :content="review.text"
          :date="format_review_date(review)"
          :additional_data="review.verified_by" 
        >
          <template v-slot:read-more>
            <div class="divider"></div>
          </template>
        </review> 
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Review from '../../../../../components/blocks/review.vue';
import { format_review_date } from '../../../utilities/reviews';

export default {
  name: 'reviews-modal', 
  components: {
    'review': Review
  },
  props: {
    reviews: Array, 
    focused_review: String, 
  }, 
  mounted() {
    if (this.focused_review) {
      const scroll = setInterval(() => {
        if (this.scroll_to_review(this.focused_review)) {
          clearInterval(scroll);
        }
      }, 100)
    }
  },
  methods: {
    format_review_date, 
    scroll_to_review(review_id) {
      if (!review_id) {
        return false;
      }  
    
      const reviews = this.$refs[review_id];
      if (!reviews || reviews.length <= 0) {
        return false;
      }

      const review = reviews[reviews.length - 1]
      const mounted = ![review.offsetLeft, review.offsetTop, review.offsetHeight, review.offsetWidth].every(v => v === 0)
      if (review && mounted) { 
        this.$refs['modal_body'].scrollTo({
          top: review.offsetTop,
          behavior: "smooth",
        });
      }
      return (review && mounted)
    }
  } 
}
</script>

<style lang="scss" scoped> 

#reviews-modal {
  max-height: 75svh;
  overflow-y: scroll;
  overflow-x: hidden;
}
 
.divider {
  border-top: 1px solid $gray-200;
  min-width: 100%;
  margin: 1rem 0;
}

</style>